import React from "react";
import {loadStripe} from "@stripe/stripe-js/pure";
//import {Elements} from "@stripe/react-stripe-js";
import PaymentEdit from "../components/Checkout/PaymentEdit"
import CheckoutForm from "../components/Checkout/CheckoutForm"
import { Elements, StripeProvider } from 'react-stripe-elements';

const STRIPE_PUBLIC_KEY = "pk_test_51H7DPFBCM9CBBVGvaIZaoCPHNaXfVRzgOGj3xxrOs4vvPG08ten56fYLQwPK9otxNGUbaBN476m0XeRlv9CoCdky005a8DBGI6"
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const CheckoutWrapper = () => {

    return (
        <StripeProvider apiKey="pk_test_51H7DPFBCM9CBBVGvaIZaoCPHNaXfVRzgOGj3xxrOs4vvPG08ten56fYLQwPK9otxNGUbaBN476m0XeRlv9CoCdky005a8DBGI6">
            <Elements>
                {/* <PaymentEdit /> */}
                <CheckoutForm />
            </Elements>
        </StripeProvider>
    );
};

export default CheckoutWrapper;